<template>
  <div class="content">
    <div class="md-layout">
      <div
        class="md-layout-item md-medium-size-100 md-xsmall-size-100 md-size-100"
      >
        <md-card>
          <md-card-header data-background-color="green">
            <h4 class="title">Platforme</h4>
          </md-card-header>
          <md-card-content>
            <ciste-platforme table-header-color="green"></ciste-platforme>
          </md-card-content>
        </md-card>
      </div>

    </div>
  </div>
</template>

<script>
import { CistePlatforme } from "@/components";

export default {
  components: {
    CistePlatforme
  }
};
</script>
